module.exports = require('./lib/url-assembler-factory')();